import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { asyncMessageRead } from '@/app/reducers/noticeSlice';

export default function useNoticeNavigate() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return useCallback((item) => {
    if (!item || !item.type) return;
    const params = item.params || {};

    let readResult = null;
    if (item.id) {
      readResult = dispatch(asyncMessageRead({ id: item.id }));
    }

    const map = {
      'join_user': () => {
        if (!params.id) return;
        navigate(`/notice/company_relevance?id=${params.id}`);
      },
      'tender_bidder': () => {
        if (!params.tender_no) return;
        window.sessionStorage.setItem('tender_no', params.tender_no);
        navigate('/supplier/bid/list');
      },
      'tender_ree': () => {
        if (!params.tender_no) return;
        window.sessionStorage.setItem('tender_no', params.tender_no);
        navigate('/buyers/tender/list');
      },
      'settlement_notice': () => {
        if (!params.settlement_order_no) return;
        navigate(`/company/settlement_doc/invoice?settlement_order_no=${params.settlement_order_no}`);
      },
      'contract_notice': () => {
        if (!params.ipp_contract_no) return;
        navigate(`/company/contract_performance/detail?ipp_contract_no=${params.ipp_contract_no}`);
      },
      'invoice_notice': () => {
        navigate('/company/invoice_notice');
      },
      'shipment_notice': () => {
        navigate(`/company/contract_performance/detail?ipp_contract_no=${params.ipp_contract_no}`);
      },
      'join_company_notice': () => {
        navigate('/apply?tab=associate');
      },
      'claim_company_notice': () => {
        navigate('/apply?tab=claim');
      },
    };

    const handler = map[item.type];
    if (handler) {
      handler();
    } else {
      console.warn(`[useNoticeNavigate] unknown notice type: ${item.type}`);
    }

    return readResult;
  }, [navigate, dispatch]);
}